import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import axios from 'axios';

import Header from '../../general/Layouts/Header';
import MenuSidebar from '../../general/Layouts/MenuSidebar';
import Pagination from "react-js-pagination";

import { scrollToTopValidate,PageTitle } from "../../general/Helpers/SettingHelper";

import { GET_QUOTELIST  } from '../../../actions';
import moment from 'moment';

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
        quotelist:'',
        quotetypelist:[],
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var loggedas = localStorage.getItem("loggedas");
    var postobject = {
    activePage: 1,
    search_all: '',
    search_type:'',
    admin_id: admin_id,
    loggedas: loggedas
    };
    this.props.getQuoteList(qs.stringify(postobject));
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
    componentDidMount() {

      

   }

   handlePageChange(pageNumber) {

     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");

     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       search_type: this.state.search_type,
       admin_id: admin_id,
       loggedas: loggedas
     };
     this.props.getQuoteList(qs.stringify(postobject))
   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    search_type: formPayload.search_type,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  this.props.getQuoteList(qs.stringify(postObject));

} 



   componentWillReceiveProps(Props){

    if (Object.keys(Props.quotelist).length > 0) {
      if (Props.quotelist[0]["status"] === "success") {
        this.setState({ totalRecord : Props.quotelist[0].records_count, quotelist: Props.quotelist[0]["quotelist"] });
        this.quotelist();
      }
    }
     
   }

   handleClickSelecetType = (event) => {

    const selectedIndex = event.target.options.selectedIndex;
    console.log(event.target.options);
    var key = event.target.options[selectedIndex].getAttribute('data-key');
  
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var loggedas = localStorage.getItem("loggedas");
  
    var postObject = {             
      activePage   : 1,
      search_type : key,
      admin_id: admin_id,
      loggedas: loggedas         
    };
  
    this.props.getQuoteList(qs.stringify(postObject));
  
    this.setState({
        Loading:true     
    })
  
  }
   quotelist() {
    var quotelist = this.props.quotelist[0];
    if (quotelist != "undefined" && quotelist != null) {
      if (quotelist.status == "success") {
        if (Object.keys(quotelist).length > 0) {
          const helperlistDetails = quotelist.quotelist.map(
            (quotelist, Index) => {

            let sno = Index+1;
            var istyle = { width: 100};
           
         var payment_type = quotelist.payment_type == null ?  quotelist.payment_type = 'N/A' : quotelist.payment_type;
         var paid_status = quotelist.paid_status == null ?  quotelist.paid_status = 'N/A' : quotelist.paid_status;

         var ride_status = quotelist.ride_status == 'tostart' ?  quotelist.paid_status = 'Assigned' : quotelist.ride_status;
          var username = quotelist.username == null ?  quotelist.username = 'N/A' : quotelist.username;
          return (
                <tr key={quotelist.id}>
          <td>{sno}</td>
          <td>{quotelist.booking_id }</td>
          <td>{quotelist.type}</td>
          <td>{quotelist.u_name}</td>
          <td>{username}</td>
          <td>{quotelist.from_location}</td>
          <td>{quotelist.to_location}</td>
          <td>{quotelist.passenger_count}</td>
           
          <td>${quotelist.original_amount}</td>
           <td>{String(ride_status).charAt(0).toUpperCase() + String(ride_status).slice(1)}</td>
          <td>{payment_type}</td>
          <td>{paid_status}</td>
          <td>{moment(quotelist.date).format('MM/DD/YYYY')}</td>   
          <td className="actiongroup">
                    <Link to={{ pathname: '/quotes-view/'+quotelist.id}} className="" title="View">  <i className="fa fa-eye" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="15" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="15" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {
    const {quotetypelist} = this.state;
    var current = this;
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="quotes" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                 <h3>Quotations</h3>
                </div>

                <div className="form-group">
                <select  onChange={current.handleClickSelecetType}  value={this.state.search_type}> 
                <option data-key="">Search by quotation type</option>
                <option data-key="Hotel">Hotel</option>
                 <option data-key="Fly">Fly</option>
                  <option data-key="Car">Car</option>
                   <option data-key="Package">Package</option>
                    <option data-key="Fun">Fun</option>
                </select>
              <div className="errorassign_quotetype"></div>
              </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div> 
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Quotation ID</th>
                  <th>Type</th>
                  <th>User</th>
                   <th>Broker</th>
                  <th>From location</th>
                  <th>To location</th>
                  <th>Passengers</th>
                  <th>Amount</th>
                  
                  <th>Quotation Status</th>
                  <th>Payment Type</th>
                  <th>Payment Status</th>
                  <th>Quoted On</th>
                  <th>View Details</th>
                   </tr>
                  </thead>
                  <tbody>{this.quotelist()}</tbody>
                </Table>
                </div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    quotelist: state.quotelist
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getQuoteList: (formVal) =>{
      dispatch({ type: GET_QUOTELIST, formVal});
   },
   
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));